import { useRef, useCallback, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useBoolean } from '@sravni/react-utils';

const lastElementForCheckScrollToTheEnd = 'lastElementForCheckScrollToTheEnd';
const useIdle = () => {
    const [isComponentVisible, setComponentVisible] = useBoolean();
    const idleTimerRef = useRef();
    const handleMouseOut = useCallback((e) => {
        const { clientWidth: width, clientHeight: height } = document.documentElement;
        if (e.clientX > width || e.clientX <= 0 || e.clientY > height || e.clientY <= 0) {
            setComponentVisible.on();
        }
    }, [setComponentVisible]);
    const scrollToTheEndObserverCallback = useCallback((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setComponentVisible.on();
            }
        });
    }, 
    // eslint-disable-next-line
    []);
    useEffect(() => {
        let lastElement = document.getElementsByClassName(lastElementForCheckScrollToTheEnd)?.[0];
        if (!lastElement) {
            lastElement = document.createElement('div');
            lastElement.classList.add(lastElementForCheckScrollToTheEnd);
            document.body.appendChild(lastElement);
        }
        const scrollToTheEndObserver = new IntersectionObserver(scrollToTheEndObserverCallback);
        scrollToTheEndObserver.observe(lastElement);
        return () => {
            scrollToTheEndObserver.unobserve(lastElement);
        };
    }, [scrollToTheEndObserverCallback]);
    useEffect(() => {
        document.addEventListener('mouseout', handleMouseOut);
        return () => {
            document.removeEventListener('mouseout', handleMouseOut);
        };
    }, [handleMouseOut]);
    const handleIdleUser = useCallback(() => {
        setComponentVisible.on();
    }, [setComponentVisible]);
    idleTimerRef.current = useIdleTimer({
        onIdle: handleIdleUser,
        timeout: 20000,
        stopOnIdle: true,
        startOnMount: false,
        startManually: true,
    });
    useEffect(() => {
        idleTimerRef.current?.start();
        return () => {
            idleTimerRef.current?.pause();
        };
    }, []);
    const onIdleComponentClose = useCallback(() => {
        setComponentVisible.off();
        idleTimerRef.current?.start();
    }, [setComponentVisible]);
    return {
        canBeVisible: isComponentVisible,
        onClose: onIdleComponentClose,
    };
};

export { useIdle };
//# sourceMappingURL=useIdle.js.map
